// extracted by mini-css-extract-plugin
export default {"collage-container":"collage_collage-container__HU4yT","collage-img":"collage_collage-img__2JVi6","collage-title":"collage_collage-title__GN2wy"};